import { ENDPOINTS, requestType } from "../constants/Variables";
import Api from "./index";


const getAllDonations = (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);
    if (params.search) queryParams.append("search", params.search);
    if (params.startDate) queryParams.append("startDate", params.startDate);
    if (params.endDate) queryParams.append("endDate", params.endDate);

    const finalUrl = queryParams.toString()
        ? `${ENDPOINTS.DONATION.GET_ALL}?${queryParams.toString()}`
        : ENDPOINTS.DONATION.GET_ALL;

    return Api(finalUrl, null, requestType.GET);
};

const getDonationByOrderId = (orderId) => {
    return Api(ENDPOINTS.DONATION.GET_SINGLE_BY_ORDER_ID.replace(":orderId", orderId), null, requestType.GET);
};

const exportDonations = (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.charityOrganization) queryParams.append("charityOrganization", params.charityOrganization);
    if (params.startDate) queryParams.append("startDate", params.startDate);
    if (params.endDate) queryParams.append("endDate", params.endDate);

    const finalUrl = queryParams.toString()
        ? `${ENDPOINTS.DONATION.EXPORT}?${queryParams.toString()}`
        : ENDPOINTS.DONATION.EXPORT;

    return Api(finalUrl, null, requestType.GET);
};

export {
    getAllDonations,
    getDonationByOrderId,
    exportDonations
};

